<template>
  <div class="col column tw-min-h-0 q-px-md q-pt-xs">
    <div
      class="col-auto row justify-center"
      v-show="showTextSearch && !isLoading && !history.length"
    >
      Contato não encontrado!
    </div>
    <div
      v-if="isLoading"
      class="col row items-center"
    >
      <div class="col-auto q-mx-auto q-my-auto">
        <q-spinner-ios
          color="primary"
          size="3em"
        />
      </div>
    </div>
    <q-virtual-scroll
      v-else
      ref="scrollsearch"
      class="col tw-min-h-0"
      :items="history"
      :virtual-scroll-slice-size="12"
      :virtual-scroll-item-size="72"
      @virtual-scroll="onScroll"
    >
      <template #default="{ item }">
        <ContactHistoryItem
          :attendance="item"
        />
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import api from '@/libs/api'
import ContactHistoryItem from './ContactHistoryItem'

export default {
  components: {
    ContactHistoryItem
  },

  props: {
    contact: {},
    memberships: {}
  },

  data () {
    return {
      isLoading: false,
      history: [],
      loadMore: false,
      showTextSearch: false,
      debounce: ''
    }
  },

  mounted () {
    this.mounted = true
  },

  beforeDestroy () {
    this.mounted = false
  },

  methods: {
    onScroll (props) {
      const countHistory = this.history.length
      const lastIndex = props.index === countHistory - 1
      const hasPhone = this.contact !== ''
      if (this.loadMore && lastIndex && hasPhone) this.loadHistory(this.contact, this.page)
    },

    async loadHistory (phone, page = 1) {
      this.showTextSearch = false

      const qtByPage = 15
      const vm = this
      if (vm.debounce) clearTimeout(vm.debounce)
      const { rows, count } = await api.loadAttendanceHistory(page, phone, this.memberships)
      const history = page === 1 ? rows : [...this.history, ...rows]
      const countHistory = history.length
      vm.page = countHistory / qtByPage + 1
      vm.loadMore = count !== 1
      vm.history = history

      vm.debounce = setTimeout(async () => {
        vm.isLoading = false
      }, 500)

      if (!rows.length) this.showTextSearch = true
    }

  },

  watch: {
    contact  (phone, oldPhone) {
      const clearSearch = phone !== oldPhone
      this.isLoading = true
      if (clearSearch) {
        this.history = []
        this.page = 1

        if (phone.length < 4) {
          this.isLoading = false
          return
        }
      }

      if (this.debounce) clearTimeout(this.debounce)
      this.debounce = setTimeout(() => this.loadHistory(phone), 500)
    }
  }
}

</script>

<style lang="sass">
  .card-history
    path
      fill: #0277BD
  .card-item
    border: 1px solid #1769B6
    border-radius: 8px
    .q-card
      border-radius: 8px

  .virtualScroll::-webkit-scrollbar
    display: none

</style>
